<template>
	<div id="toothFocusControls" class="tooth-focus-mode-item">
		<div id="toothFocusHint">Click tooth to focus</div>
	</div>
</template>

<script>

export default {
	name: "ToothFocusControls",
	props: [],
	components: {},
	methods: {
		
	}
};

</script>

<style scoped>

#toothFocusControls {
	display: none;
	left: calc(50% - 180px);
	top: 30px;
	width: 350px;
	position: absolute;
	z-index: 9;
}

#toothFocusHint {
	width: 350px;
	text-align: center;
	color: #ffffff;
}

</style>